import type { FeaturedAlertItem } from "@/lib/api-client";
import type { LibraryItem } from "@/lib/mock/library";
import { contentTag } from "@/lib/content-tag";

const AUTOMATION_ACCENT = "#a78bfa";

/**
 * Map a featured alert (GET /alerts/featured) into a Library card item so the
 * Library Automations section shows the REAL published automations with their
 * generated thumbnails, instead of placeholder icon cards.
 */
export function featuredAlertToLibraryItem(a: FeaturedAlertItem): LibraryItem {
  const schedule = a.schedule_description || a.schedule || "Scheduled";
  const handle = a.presented_by?.handle ? `@${a.presented_by.handle}` : "";
  return {
    id: a.alert_id,
    kind: "automation",
    title: a.name,
    blurb: a.description || "",
    meta: handle ? `${handle} · ${schedule}` : schedule,
    accent: AUTOMATION_ACCENT,
    topic: "",
    thumbnailUrl: a.thumbnail_url || null,
    uses: a.subscriber_count || 0,
    tags: [contentTag(`${a.name} ${a.description || ""}`)],
  };
}
